import { makeVar, useReactiveVar } from "@apollo/client";
import { useCallback } from "react";

/** Session-only panel preferences, isolated by surface and list/scenario. */
const expandedPanels = makeVar<Readonly<Record<string, boolean>>>({});

/**
 * Keeps each panel's state when its Pitch view is unmounted.
 * @param key - Surface, entity and side identity.
 * @returns Current expansion and a stable toggle.
 */
export function usePitchPanelExpanded(key: string) {
  const state = useReactiveVar(expandedPanels);
  const toggle = useCallback(() => {
    const current = expandedPanels();
    expandedPanels({ ...current, [key]: !(current[key] ?? true) });
  }, [key]);
  const expand = useCallback(() => {
    expandedPanels({ ...expandedPanels(), [key]: true });
  }, [key]);
  return { expanded: state[key] ?? true, toggle, expand };
}
